define([
  'angular',
  'mod',

], function(angular, mod) {

var m = require('am');

m.factory('modal', ['overlay', function(overlay) {
  /*
  Service for showing modals (e.g. the login form).
  Usage:
    modal({contents: 'contents'})
    modal({template: 'template.html'})
  */

  return function modal(options) {
    if (options.content) {
      options.content = '<div class="contents">' + options.content + '</div>';
    } else if (options.template) {
      options.content = '<div class="contents" ng-include="template"></div>';
    }
    options.class = options.class || '';
    options.class = options.class.concat(' modal');
    options.type = 'modal';
    overlay.show(options);
    return overlay;
  };
}]);

m.factory('modalForm', ['modal', '$q', function(modal, $q) {
  return function modalForm(context) {
    var deferred = $q.defer();
    var p = deferred.promise;
    p.cancel = function() {
      deferred.reject('canceled');
      p.overlay.hide();
    };
    _.defaults(context, {
      data: {},
      submit: function(data) {
        deferred.resolve(data);
        p.overlay.hide();
      },
      cancel: p.cancel
    });
    p.overlay = modal(context);
    return p;
  };
}]);

angular.forEach(['tooltip', 'htmlTooltip'], function(directiveName) {
  m.directive(directiveName, ['overlay', '$document', '$interval', function(overlay, $document, $interval) {
    /*
    Uses the overlay service to create a tooltip below the current element's
    parent (specifically made for the scoring interface at the moment, can be
    made more generic as need arises).

    Inline template:
    <div tooltip="{{tooltiptext}}"></div>

    External template:
    <div html-tooltip="'mytemplate.html'"></div>
    */
    return {
      restrict: 'A',
      link: function(scope, lElement, lAttrs) {
        var interval;
        lElement.on('mouseenter', function(ev) {
          if (lAttrs[directiveName] && ev.target === lElement[0]) {
            var data = {
              scope: scope,
              style: {'max-width': 300 + 'px'},
              class: 'tooltip'
            };
            var doc = $document[0].documentElement;
            if (doc.clientWidth - ev.clientX < 300) {
              data.style.left = ev.pageX - 300 + 'px';
            } else {
              data.style.left = ev.pageX + 'px';
            }
            if (ev.clientY > doc.clientHeight / 2) {
              data.style.bottom = $document[0].body.offsetHeight - ev.pageY + 'px';
            } else {
              data.style.top = ev.pageY + 'px';
            }
            if (directiveName === 'tooltip') {
              data.content = lAttrs[directiveName];
            } else if (directiveName === 'htmlTooltip') {
              data.template = scope.$eval(lAttrs[directiveName]);
            }
            overlay.show(data);
            scope.$apply();

            interval = $interval(function() {
              if(lElement[0].offsetHeight === 0) {
                overlay.hide();
                $interval.cancel(interval);
              }
            }, 1000);
          }
        });

        lElement.on('mouseleave', function(ev) {
          $interval.cancel(interval);
          if (ev.target === lElement[0]) {
            overlay.hide();
          }
        });
      }
    };
  }]);
});

angular.forEach(['anchoredTooltip', 'htmlAnchoredTooltip'], function(directiveName) {
  m.directive(directiveName, ['overlay', function(overlay) {
    /*
    Uses the overlay service to create a tooltip below the current element's
    parent (specifically made for the scoring interface at the moment, can be
    made more generic as need arises).

    Inline template:
    <div anchored-tooltip="{{tooltiptext}}"></div>

    External template:
    <div html-anchored-tooltip="'mytemplate.html'"></div>
    */
    return {
      restrict: 'A',
      link: function(scope, lElement, lAttrs) {
        lElement.on('mouseenter', function(ev) {
          if (ev.target === lElement[0]) {
            var box = lElement.parent()[0].getBoundingClientRect();
            var data = {
              scope: scope,
              style: {
                top: box.bottom + 'px',
                width: box.width + 'px',
                left: box.left + 'px'
              },
              class: 'anchored_tooltip'
            };
            if (directiveName === 'anchoredTooltip') {
              data.content = scope.$eval(lAttrs[directiveName]);
            } else if (directiveName === 'htmlAnchoredTooltip') {
              data.template = lAttrs[directiveName];
            }
            overlay.show(data);
            scope.$apply();
          }
        });

        lElement.on('mouseleave', function(ev) {
          if (ev.target === lElement[0]) {
            overlay.hide();
          }
        });
      }
    };
  }]);
});

angular.forEach(['anchoredModal', 'htmlAnchoredModal'], function(directiveName) {
  m.directive(directiveName, ['overlay', function(overlay) {
    /*
    */
    return {
      restrict: 'A',
      link: function(scope, lElement, lAttrs) {
        lElement.on('click', function(ev) {
          if (ev.target === lElement[0]) {
            var parent = lElement.parent().parent()[0].getBoundingClientRect();
            var data = {
              scope: scope,
              style: {
                top: '1em',
                width: parent.width + 'px',
                left: parent.left + 'px',
                bottom: '1em',
                overflow: 'auto'
              },
              class: 'modal detailed_scoring'
            };
            if (directiveName === 'anchoredModal') {
              data.content = scope.$eval(lAttrs[directiveName]);
            } else if (directiveName === 'htmlAnchoredModal') {
              data.template = lAttrs[directiveName];
            }
            overlay.show(data);
            scope.$apply();
          }
        });
      }
    };
  }]);
});


m.factory('overlay', ['$document', '$compile', '$timeout', '$rootScope', function($document, $compile, $timeout, $rootScope) {
  /*
  This service provides a simple way to show and hide bits of content that
  overlay the page. Intended for things such as tooltips and modal dialogs.

  It expects an object with the following config:
  {
    content: '', // text or html to be inserted into the tooltip.
    template: '', // Use instead of 'content' to use a template.
    styles: {...}, // name:value pairs with css styles to be applied to the container element.
    scope: scope // scope to use as the parent scope of the object.
    class: "class names" // classes to be added to the container in addition to "overlay"
  }
  */

  var overlay_container = angular.element('<div class="overlay_container"></div>');
  angular.element($document[0].body).append(overlay_container);
  var scopes = [];

  var funcs = {
    show: function(args) {
      var overlay_el = angular.element('<div class="overlay hidden"></div>');
      if (args.content) {
        overlay_el.html(args.content);
      } else if (args.template) {
        overlay_el.attr('ng-include', 'template');
      }
      var styles = ['position:absolute'];
      if (args.style) {
        // This allows the directive to control positioning logic.
        angular.forEach(args.style, function(value, key) {
          styles.push(key + ':' + value);
        });
      }
      overlay_el.attr('style', styles.join(';'));

      if (args.class) overlay_el.addClass(args.class);

      var scope;
      if (args.scope) {
        if ('$new' in args.scope) {
          scope = args.scope.$new();
        } else {
          scope = $rootScope.$new();
          for (var item in args.scope) {
            scope[item] = args.scope[item];
          }
        }
      } else {
        scope = $rootScope.$new();
      }
      $rootScope.$broadcast('$overlayShow', args);
      scopes.push(scope);
      angular.forEach(args, function(value, key) {
        if (key != 'scope') {
          scope[key] = value;
        }
      });
      scope.hideOverlay = funcs.hide;
      overlay_container.append(overlay_el);
      $compile(overlay_el)(scope);
      $timeout(function() {
        overlay_container.children().removeClass('hidden');
      }, 250);
    },
    hide: function() {
      try {
        overlay_container.html('');
        while (scopes.length) {
          scopes.pop().$destroy();
        }
      } catch (ex) {}
      $rootScope.$broadcast('$overlayHide');
    }
  };
  return funcs;
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Overlays/Overlays.js
 **/